import { render, staticRenderFns } from "./OrderAutoCompleter.vue?vue&type=template&id=229f6d10&"
import script from "./OrderAutoCompleter.vue?vue&type=script&lang=js&"
export * from "./OrderAutoCompleter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports